import { gql } from "@apollo/client";

export const GET_PROVINCE = gql`
  query GetProvince {
    getProvince {
      count
      currentPage
      message
      nextPage
      prevPage
      success
      totalPages
      result {
        countryId
        createdBy
        createdDate
        isActive
        modifiedBy
        modifiedDate
        provinceId
        provinceName
        include
      }
    }
  }
`;